import dayjs from "dayjs";
dayjs.locale('es')
export const formatoFechaDaysRedus =(fecha) =>{
    if (!fecha) {
        return ''
    }

    let fec = dayjs(fecha).format('dddd DD MMM YYYY')
    return fec.substring(0, 1).toUpperCase() + fec.substring(1, fecha.length)
}